import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterComponent } from './components/filter/filter.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ViewPdfComponent } from './view-pdf/view-pdf.component';
import { PdfSignerComponent } from './pdf-signer/pdf-signer.component';
import { ValidationMessageComponent } from './components/validation-message/validation-message.component';

const components = [
  PaginationComponent,
  FilterComponent,
  ViewPdfComponent,
  PdfSignerComponent,
  ValidationMessageComponent
]

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule
  ],
  exports: [...components]
})
export class SharedModule { }
